import { useMemo, useState, useEffect, useCallback } from "react";
import { useTable } from "react-table";
import Modal from "react-bootstrap/Modal";
import middleware from "../../../Api/Middleware";
import { useNavigate, useLocation } from "react-router";
import "../../../Main/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, } from "@fortawesome/free-solid-svg-icons";
import Cookies from "universal-cookie";
import SortableHeader from '../../../Table/TableComponents/SortableHeader';
import CheckboxHeader from "../../../Table/TableComponents/CheckboxHeader";
import CheckboxCell from "../../../Table/TableComponents/CheckboxCell";
import PageTemplate from "../../../Templates/PageTemplate";
import TablePreset from "../../../Table/TablePreset";
import { BorderedDropDown } from "../../../HouseStyle/Components/DropDowns";
import { BackButton, ButtonBlue, ButtonLightGrey } from "../../../HouseStyle/Components/Buttons";
import { BorderedTextInput } from "../../../HouseStyle/Components/Inputs";
import ToastError from "../../../Toasts/ToastError";
import Filters from "../../../Filters/Filters";

function BlueprintSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const cookies = new Cookies();

  // Filter logic
  const defaultFilters = [
    {
      index: 0,
      order: 1,
      value: 1,
      name: "Status blauwdruk",
      field: "status",
      type: "radio",
      options: [
        { name: "Gepubliceerd", value: 1 },
        { name: "Gearchiveerd", value: 0 },
      ],
    },
  ];

  const [tempfilters, setTempFilters] = useState(defaultFilters);
  const [filters, setFilters] = useState(defaultFilters);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [loading, setLoading] = useState(true); // useState for page loading  
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(true); // useState for the Loadingscreen
  const [blueprints, setBlueprints] = useState([]); // useState for all products in the database
  const [sizes, setSizes] = useState([]); // useState for all products in the database
  const [pagination, setPagination] = useState({
    page_size: 10,
    page: 1,
    max_items: 0,
    begin_of_page: 0,
    end_of_page: 0,
  }); // the useState for the pagination for the table
  const [order, setOrder] = useState({ orderBy: "", direction: "" }); // useState for ordering the columns in the table
  const [selectedProductIds, setSelectedProductIds] = useState([]); // usestate for the selected checkboxes
  const [blueprintsSearchengine, setBlueprintsSearchengine] = useState("");
  const [inputChangeInternalCode, setInputChangeInternalCode] = useState("");
  const [searchBar, setSearchBar] = useState("");
  // const [blueprintData, setBlueprintData] = useState([]);
  const [show, setShow] = useState(false);
  const [blueprintName, setBlueprintName] = useState("");
  const [showModalBlueprint, setShowModalBlueprint] = useState(false);
  const [showModalBlueprintNew, setShowModalBlueprintNew] = useState(false);
  const [borderedSelectedOption, setBorderedSelectedOption] = useState(false);
  const [usedTemplates, setUsedTemplates] = useState([]);

  // Filter modal close function
  const CloseFilterModal = () => {
    setShowFilterModal(false);
  };

  // fetched all the products and the stock an the colors from the database
  const fetchAll = async () => {
    try {
      setLoading(true);
      const searchQuery = searchBar.trim() ? `&searchTerm=${encodeURIComponent(searchBar.trim())}&noSearch=[blueprint_id,size_ids,status,created_at]` : "";

      // Build filter query in the format expected by PHP filtering system
      const filterQuery = filters
        .filter((e) => e.value != null && e.value !== "")
        .map((e) => `${e.field}=${e.value}`)
        .join("|"); // Use | separator as expected by PHP

      // Add filtering parameter if filters exist
      const filterParam = filterQuery ? `&filtering=${encodeURIComponent(filterQuery)}` : "";

      const [fetchBlueprints, fetchSizes] = await Promise.all([
        middleware.get(`sp/blueprintsTableAll?page=${pagination.page}&page_size=${pagination.page_size}${order.orderBy !== "" && order.direction !== "" ? `&orderBy=${order.orderBy}&orderDirection=${order.direction}` : ""}${searchQuery}${filterParam}`),
         middleware.get(`products/sizes`),
      ]);
      setBlueprints(fetchBlueprints.data.data);
      setSizes(fetchSizes.data.data);
      setUsedTemplates(fetchBlueprints.data.usedTemplates);
      setPagination({
        ...pagination,
        max_items: fetchBlueprints.data.total,
        begin_of_page: fetchBlueprints.data.from,
        end_of_page: fetchBlueprints.data.to,
      });
      setLoadingScreenFunc();
    } catch (error) {
      if (error.response.status === 401) {
        cookies.remove("token", { path: "/" });
        navigate("/");
      }
    }
  };

  // fetches all the data when pagination.page_size, pagination.page, order or location.pathname changes
  useEffect(() => {
    fetchAll();
  }, [pagination.page_size, pagination.page, order, location.pathname, filters]); // Added filters to dependency array

  useEffect(() => {
    fetchAll();
  }, []);

  //   useEffect(() => {
  //     try {
  //       if (blueprintsSearchengine.trim() === "" && blueprintsSearchengine === "") {
  //         // Code to fetch all when searchengine is empty
  //         fetchAll();
  //       } else if (blueprintsSearchengine.trim() !== "") {
  //         // Code to perform the search when searchengine has actual characters
  //         const doIt = async () => {
  //           const [fetchBlueprints] = await Promise.all([
  //             middleware.get(
  //               `products/sizes/blueprints?page=${pagination.page}&page_size=${pagination.page_size}&searchTerm=${blueprintsSearchengine}&noSearch=[updated_at,created_at]`
  //             ),
  //           ]);
  //           setBlueprints(fetchBlueprints.data.data);
  //           setPagination({
  //             ...pagination,
  //             max_items: fetchBlueprints.data.total,
  //             begin_of_page: fetchBlueprints.data.from,
  //             end_of_page: fetchBlueprints.data.to,
  //           }); // sets the pagination usestate with the max items begin of the page and the end of the page
  //         };
  //         doIt();
  //       } 
  //     } catch (error) {
  //       if (error.response.status === 401) {
  //         cookies.remove("token", { path: "/" });
  //         navigate("/");
  //       }
  //     }
  // }, [blueprintsSearchengine]);


  useEffect(() => {
    try {
      if (searchBar.trim() === "" && searchBar === "") {
        // Code to fetch all when searchengine is empty
        fetchAll();
      } else if (searchBar.trim() !== "") {
        fetchAll();
      }
    } catch (error) {
      if (error.response.status === 401) {
        cookies.remove("token", { path: "/" });
        navigate("/");
      }
    }

  }, [searchBar]);

  // handles to close the de-activate modal
  const handleCloseBlueprint = () => setShowModalBlueprint(false);
  const handleCloseBlueprintNew = () => setShowModalBlueprintNew(false);

  //handles to show the de-activate modal
  const handleShow = () => setShow(true);
  const handleShowBlueprint = () => setShowModalBlueprint(true);


  // sets loading on false an waits 0.5 sec to also set the Loadingscreen to false
  function setLoadingScreenFunc() {
    setLoading(false);
    setTimeout(() => {
      setLoadingScreen(false);
    }, 500);
  }

  const handleBlueprintData = (data) => {
    localStorage.setItem("Blueprintdata", JSON.stringify(data));
    navigate("./bewerken");
  };

  // Handle checkbox selection
  const handleProductSelection = (productId, isSelected) => {
    if (isSelected) {
      setSelectedProductIds([...selectedProductIds, productId]);
    } else {
      setSelectedProductIds(
        selectedProductIds.filter((id) => id !== productId)
      );
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <CheckboxHeader currentItem={blueprints} selectedIds={selectedProductIds} setSelectedIds={setSelectedProductIds} pk={'blueprint_id'}>
          </CheckboxHeader>
        ),
        accessor: "select",
        Cell: ({ row }) => {
          return <CheckboxCell row={row} handleSelection={handleProductSelection} selectedIds={selectedProductIds} pk={'blueprint_id'} />
        }
      },
      {
        Header: () => (
          <SortableHeader currentItem={order} setItem={setOrder} field="title" pos={"start"}>
            Blauwdruk
          </SortableHeader>
        ),
        accessor: 'title',
        Cell: ({ row }) => {
          return <a className="FlatTextLink text-decoration-none text-nowrap" onClick={() => handleBlueprintData(row.original)}>{row.original.title}</a>
        }
      },
      {
        Header: () => (
          <SortableHeader currentItem={order} setItem={setOrder} field="size_names" pos={"start"}>
            Maten
          </SortableHeader>
        ),
        accessor: 'size_names',
        Cell: ({ row }) => {
          return <div>{row.original.size_names}</div>
        }
      },
      {
        Header: () => (
          <SortableHeader
            currentItem={order}
            setItem={setOrder}
            field={"status"}
            pos={"end"}
          >
            Status
          </SortableHeader>
        ),
        accessor: "status",
        Cell: ({ row }) => {
          return <div className="text-end" style={{ color: row.original.status == "1" ? "#A9D974" : "#ffcc9d" }}>
            {row.original.status == "1" ? "Gepubliceerd" : "Gearchiveerd"}
          </div>
        }
      },
    ],
    [order.orderBy, order.direction, selectedProductIds, setSelectedProductIds, blueprints,]
  );

  //   Table instance
  const tableInstance = useTable({ columns, data: blueprints });

  const handleSearchChange = useCallback((value) => {
    setSearchBar(value);
    setPagination(prev => ({ ...prev, page: 1 }));
  }, []);

  const submitBlueprint = async (event) => {
    event.preventDefault();
    if (blueprintName.trim() === "") {
      ToastError("Veld mag niet leeg zijn", 'empty_blueprint_name');
      return;
    }
    try {
      const blueprintResponse = await middleware.post(
        `products/sizes/blueprints`,
        {
          title: blueprintName,
        }
      );

      localStorage.setItem(
        "Blueprintdata",
        JSON.stringify(blueprintResponse.data.data)
      );
      setBlueprintName("");
      handleCloseBlueprintNew();
      navigate("./bewerken");
    } catch (error) {
        console.error(error);
    
      // Check if it's a duplicate entry error
      if (error.response?.data?.error) {
        const errorMessage = error.response.data.error;
        
        // Check if a validation error gets returned.
        if (errorMessage.includes('taken') ) {
          ToastError(`Blueprint "${blueprintName}" bestaat al. Kies een andere naam.`, 'duplicate_blueprint');
        } else {
          // Generic error message for other database errors
          ToastError("Er is een fout opgetreden bij het toevoegen van de blueprint.", 'blueprint_add_error');
        }
      } else {
        // Fallback error message
        ToastError("Er is een onbekende fout opgetreden. Probeer het opnieuw.", 'unknown_error');
      }
    }
  };

  const Action = (methode) => {
    if (methode === "suspend") {
      handleShow();
    } else if (methode === "publish") {
      activateBlueprintSize();
    }
  }

  const activateBlueprintSize = async () => {
    try {
      const promises = selectedProductIds.map(id =>
        middleware.put(`products/sizes/blueprints`, {
          blueprint_id: id,
          status: 1,
        }));
      await Promise.all(promises);
      setSelectedProductIds([]);
      fetchAll();
    } catch (error) {
      console.error("Error deactivating sizes:", error);
    }
  }

  const deactivateBlueprintSize = async () => {
    try {
      const promises = selectedProductIds.map(id =>
        middleware.put(`products/sizes/blueprints`, {
          blueprint_id: id,
          status: 0,
        }));
      await Promise.all(promises);
      setSelectedProductIds([]);
      fetchAll();
    } catch (error) {
      console.error("Error deactivating sizes:", error);
    }
  }

  const TEMPLATES = [
    { id: 1, title: "Internationale maten 1: XXS | XS | S | M | L | XL | XXL | XXXL | 4XL | 5XL | 6XL", value: "Internationale maten 1: XXS | XS | S | M | L | XL | XXL | XXXL | 4XL | 5XL | 6XL" },
    { id: 2, title: "Internationale maten 2: XXS | XS | S | M | L | XL | XXL | XXXL", value: "Internationale maten 2: XXS | XS | S | M | L | XL | XXL | XXXL" },
    { id: 3, title: "Kindermaten: 104 | 110 | 116 | 122 | 128 | 134 | 140 | 146 | 152 | 154 | 158 | 164 | 170 | 176", value: "Kindermaten: 104 | 110 | 116 | 122 | 128 | 134 | 140 | 146 | 152 | 154 | 158 | 164 | 170 | 176" },
    { id: 4, title: "Riemmaten: 80 | 85 | 90 | 95 | 100 | 105 | 110 | 115 | 120 | 125 | 130", value: "Riemmaten: 80 | 85 | 90 | 95 | 100 | 105 | 110 | 115 | 120 | 125 | 130" },
    { id: 5, title: "Schoenmaten 1: 36 | 37 | 38 | 39 | 40 | 41 | 42", value: "Schoenmaten 1: 36 | 37 | 38 | 39 | 40 | 41 | 42" },
    { id: 6, title: "Schoenmaten 2: 36 | 36.5 | 37 | 37.5 | 38 | 38.5 | 39 | 39.5 | 40 | 40.5 | 41 | 41.5 | 42", value: "Schoenmaten 2: 36 | 36.5 | 37 | 37.5 | 38 | 38.5 | 39 | 39.5 | 40 | 40.5 | 41 | 41.5 | 42" },
    { id: 7, title: "Duomaten: XS/S | S/M | M/L | L/XL", value: "Duomaten: XS/S | S/M | M/L | L/XL" },
    { id: 8, title: "32-34-36: 32 | 34 | 36 | 38 | 40 | 42", value: "32-34-36: 32 | 34 | 36 | 38 | 40 | 42" },
  ];

  const getTemplatesWithDisabled = () => {
    return TEMPLATES.map(template => {
      const temp=usedTemplates.find((e) => e.used === template.id); 
      return {
        ...template,
        disabled: temp,
        title: temp
          ? `${template.title} ${
              temp.status === 0
                ? "(Gearchiveerd)"
                : "(Al gebruikt)"
            }`
          : template.title,
      };
  });
  };

  const handleAddTemplate = async () => {
    try {
      // Split the selected value into an array of sizes
      const [title, sizesString] = borderedSelectedOption.split(': ');
      const sizesToProcess = sizesString.split(' | ');
      
      // Get the template ID from the selected option
      const selectedTemplate = TEMPLATES.find(t => t.value === borderedSelectedOption);
      const templateId = selectedTemplate?.id;

      // Collect all existing sizes from sizes useState (lowercase for comparison)
      const existingSizesMap = new Map();
      
      sizes.forEach(size => {
        // Store with lowercase key for comparison, but keep original ID
        if (size.size_id && size.main) {
          existingSizesMap.set(size.main.trim().toLowerCase(), size.size_id);
        }
      });

      // Arrays to hold IDs and sizes to create
      const existingIds = [];
      const sizesToCreate = [];
      
      // Check which sizes already exist and which need to be created
      sizesToProcess.forEach((size, index) => {
        const trimmedSize = size.trim();
        const lowercaseSize = trimmedSize.toLowerCase();
        
        if (existingSizesMap.has(lowercaseSize)) {
          // Size already exists, use existing ID
          existingIds.push({
            id: existingSizesMap.get(lowercaseSize),
            order: index + 1
          });
        } else {
          // Size doesn't exist, needs to be created
          sizesToCreate.push({
            main: trimmedSize,
            sorting_order: index + 1
          });
        }
      });

      let allSizeIds = [];
      
      // Create new sizes if there are any to create
      if (sizesToCreate.length > 0) {
        const sizeResponse = await middleware.post(`products/sizes`, {
          bulk_data: sizesToCreate,
        });
        
        // Extract newly created size IDs
        const newSizeIds = sizeResponse.data.data.map(size => size.size_id);
        
        // Combine existing and new IDs in correct order
        let newIdIndex = 0;
        sizesToProcess.forEach((size, index) => {
          const trimmedSize = size.trim();
          const lowercaseSize = trimmedSize.toLowerCase();
          
          if (existingSizesMap.has(lowercaseSize)) {
            allSizeIds[index] = existingSizesMap.get(lowercaseSize);
          } else {
            allSizeIds[index] = newSizeIds[newIdIndex];
            newIdIndex++;
          }
        });
      } else {
        // All sizes already exist, use existing IDs in correct order
        allSizeIds = sizesToProcess.map(size => existingSizesMap.get(size.trim().toLowerCase()));
      }

      // Create the blueprint with the size IDs and mark template as used
      const blueprintData = { 
        title: title, 
        size_ids: allSizeIds.join(',')
      };
      
      // Add template ID if a template was used
      if (templateId) {
        blueprintData.used = templateId;
      }
      
      await middleware.post('products/sizes/blueprints', blueprintData);

      // Clear the selected template after successful creation
      setBorderedSelectedOption('');
      
      handleCloseBlueprint();
      fetchAll();
    } catch (error) {
      console.error('Error creating blueprint and sizes:', error);
    }
  };

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} centered size="xl">
        <Modal.Header className="modalTop d-flex justify-content-between">
          <Modal.Title className="ms-3 BlockTitle ">Let op!</Modal.Title>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={() => setShow(false)}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter pb-0 justify-content-around">
          <div className="ms-3">
            U gaat {selectedProductIds.length}{" "}
            {selectedProductIds.length === 1 ? "item" : "items"} archiveren. Weet U
            dat zeker?
          </div>
        </Modal.Body>
        <Modal.Footer className="modalBottom">
          <div className="d-flex flex-row">
            <div className="me-3">
              <ButtonLightGrey text={"Annuleren"} className="ms-3 btn bg-danger text-white" onClickFunction={() => setShow(false)} />
            </div>
            <ButtonBlue
              text={"Archiveren"}
              onClickFunction={() => {
                setShow(false);
                deactivateBlueprintSize();
              }}
            />
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        id="modalBlueprint"
        show={showModalBlueprint}
        onHide={handleCloseBlueprint}
        centered
        size="xl"
      >
        <Modal.Header className="modalTop d-flex justify-content-between">
          <Modal.Title className="ms-2">Kies een Template</Modal.Title>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={handleCloseBlueprint}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter justify-content-around">
          <div className="ms-2">
            <div className="FlatText">Kies een template dat je wilt toevoegen als blauwdruk</div>
            <BorderedDropDown
              placeholder="Templates"
              options={getTemplatesWithDisabled()}
              selectedValue={borderedSelectedOption}
              setSelectedValue={setBorderedSelectedOption}
              searchable={true}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="modalBottom">
          <ButtonBlue text="Toevoegen" onClickFunction={() => handleAddTemplate()} />
        </Modal.Footer>
      </Modal>

      <Modal
        id="modalBlueprint"
        show={showModalBlueprintNew}
        onHide={handleCloseBlueprintNew}
        centered
        size="xl"
      >
        <Modal.Header className="modalTop d-flex justify-content-between">
          <Modal.Title className="ms-2">Nieuwe Blauwdurk</Modal.Title>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={handleCloseBlueprintNew}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <form onSubmit={submitBlueprint}>
          <Modal.Body className="modalCenter justify-content-around pb-2">
            <BorderedTextInput
              className="optionsList optionListWidt text-center mt-4 w-100 border-black"
              placeholder="Blauwdruk naam"
              name="blueprint_name"
              inputValue={blueprintName}
              setInputValue={setBlueprintName}
              required={true}
            ></BorderedTextInput>
          </Modal.Body>
          <Modal.Footer className="modalBottom">
            <ButtonBlue text={"Aanmaken"} type="submit" className="btn bg-info mt-3 text-white" />
          </Modal.Footer>
        </form>
      </Modal>

      <PageTemplate navbarTitle={"Blauwdrukken Overzicht"}>
        <div className="w-100">
          <div>
            <BackButton
              text={'Terug'}
              onClickFunction={() => navigate('/algemene/instellingen/product')}
            />
          </div>

          <div className="blueprintsOverview">
            <div className="tableBlueprints">
              <TablePreset
                data={[{ 'selectedIds': selectedProductIds, 'tableInstance': tableInstance, 'pagination': pagination, 'primary_key': 'blueprint_id' }]}
                tableLoading={loading}
                setPagination={setPagination}
                handleSelection={handleProductSelection}
                searchBar={[{ placeholder: 'Zoek op blauwdruk of maten...', shown: true, searchFunction: handleSearchChange, }]}
                actionOptions={[{ title: "Archiveren", function: () => Action("suspend") }, { title: "Publiceren", function: () => Action("publish") }]}
                leftButtons={[
                  { title: "Filteren", function: () => setShowFilterModal(true) }
                ]}
                rightButtons={[{ title: "Handmatig aanmaken", function: () => setShowModalBlueprintNew(true) }, { title: "Templates", function: () => handleShowBlueprint() }]}
              />
            </div>
          </div>
        </div>
        <Filters
          filters={tempfilters}
          showFilterModal={showFilterModal}
          closeFilterModal={CloseFilterModal}
          setTempFilters={setTempFilters}
          setFilters={setFilters}
          defaultFilters={defaultFilters}
        />
      </PageTemplate>
    </>
  );
}

export default BlueprintSettings;

